import { render } from "./PrivacyPolicyText.vue?vue&type=template&id=d6212e4a&scoped=true"
import script from "./PrivacyPolicyText.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyText.vue?vue&type=script&lang=js"

import "./PrivacyPolicyText.vue?vue&type=style&index=0&id=d6212e4a&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6212e4a"]])

export default __exports__